import React from 'react';
import { css } from '@emotion/react';
import PhoneNumber from '../../molecules/phone-number';
import Typography from '../../primitives/typography';
import { colors } from '../../primitives/colors';

const styles = {
    typography: css({
        color: colors.primaryOrange,
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        span: {
            lineHeight: 1,
        },
    }),
};

const StyledPhoneNumber = ({
    children,
    href,
    ...props
}: React.PropsWithChildren<{ href: string }> & Omit<
Omit<React.HTMLProps<HTMLDivElement>, 'color'>,
'as'>): JSX.Element => (
    <Typography
        fontSize={{
            dt: 'lg',
        }}
        css={styles.typography}
        {...props}
    >
        <span>
            <PhoneNumber href={href}>{children as string}</PhoneNumber>
        </span>
    </Typography>
);

export default StyledPhoneNumber;
